// extracted by mini-css-extract-plugin
export default {"wrapper":"PaymentStats_wrapper__n41uq"};